export { default } from './AcknowledgementModal';
